export const EMAIL = 'submit@shutterstock.com';
